import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import { Card, CardBody } from "reactstrap";
import LoadingOverlay from "react-loading-overlay-ts";
import DNALoader from "../../components/Loaders/DnaLoader";
import "../../assets/custom css/loadoverlay.scss";
import Alerts from "../../components/Alerts/alerts";
import ItemService from "./Item.service";
import AuthService from "../Authentication/auth.service";
import { useNavigate } from 'react-router-dom';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { createGlobalStyle } from 'styled-components';
import PermissionAccess from '../../PermissionAccess/Access.js';
import { getFileUrl, uploadFile } from "../../utils/fileUtils";

const imageStyle = {
  width: 'auto',
  height: '200px',
  objectFit: 'cover',
  margin: '0px auto',
};

const slideStyle = {};

const customSliderStyles = `
  .slick-prev,
  .slick-next {
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
    width: 30px;
    height: 30px;
    z-index: 1;
  }

  .slick-prev:hover,
  .slick-next:hover {
    background-color: rgba(0, 0, 0, 0.8);
  }

  .slick-prev {
    left: 10px;
  }

  .slick-next {
    right: 10px;
  }

  .slick-prev:before,
  .slick-next:before {
    font-size: 20px;
    line-height: 1;
    opacity: 0.75;
    color: white;
  }
`;

const GlobalStyle = createGlobalStyle`
  ${customSliderStyles}
`;

const DriverInsertionForm = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);
  const form = useRef();
  const [pre_params, setpre_params] = useState('');
  const [collectionlist, setcollectionlist] = useState([]);
  const [fieldlist, setfieldlist] = useState([]);
  const [fieldlist_validate, setfieldlist_validate] = useState([]);
  const [item_name, setItem_name] = useState('');
  const [itemType, setItemType] = useState('');
  // const [amount, setamount] = useState('');
  const [description, setDescription] = useState('');
  const [selectedImages, setSelectedImages] = useState([]);
  const [errors, setErrors] = useState({});
  const { authData, accessPages, super_admin, current_module } = PermissionAccess();
  const [categoryError, setCategoryError] = useState('');
  const [statusError, setStatusError] = useState('');
  const [skuError, setSkuError] = useState('');
  const [businessError, setBusinessError] = useState('');
  const [imageError, setImageError] = useState('');

  const handleFileChange = async (event) => {
    const files = Array.from(event.target.files);
    if (!files.length) {
      return;
    }

    setLoading(true);
    try {
      const paths = await Promise.all(files.map((file) => uploadFile(file)));
      setSelectedImages((prevImages) => [...prevImages, ...paths]);
    } catch (error) {
      Alerts.swalErrorAlert(error.message || t("Image upload failed."));
    } finally {
      setLoading(false);
    }
  };

  const stored_user = authData.userData
  let business = []
  if (stored_user.businesses) {
    business = stored_user.businesses
  }
  const validateForm = () => {
    let formErrors = {};

    if (!item_name.trim()) formErrors.item_name = "Item Name is required";
    if (!description.trim()) formErrors.description = "Description is required";
    // if (!amount) formErrors.amount = "Price is required";
    if (!itemType) formErrors.item_type = "Item Type is required";
    

    // Add category validation
  const categoryField = fieldlist.find(field => field.referal_name === 'category');
  if (categoryField) {
    const categoryValue = document.getElementById(categoryField.referal_name)?.value;
    if (!categoryValue) {
      formErrors[categoryField.referal_name] = "Category is required";
      setCategoryError("Category is required");
    } else {
      setCategoryError("");
    }
  }

  // Status validation
  const statusField = fieldlist.find(field => field.referal_name === 'status');
  if (statusField) {
    const statusValue = document.getElementById(statusField.referal_name)?.value;
    if (!statusValue) {
      formErrors[statusField.referal_name] = "Status is required";
      setStatusError("Status is required");
    } else {
      setStatusError("");
    }
  }

  // SKU validation
  const skuField = fieldlist.find(field => field.referal_name === 'sku');
  if (skuField) {
    const skuValue = document.getElementById(skuField.referal_name)?.value;
    if (!skuValue) {
      formErrors[skuField.referal_name] = "SKU is required";
      setSkuError("SKU is required");
    } else {
      setSkuError("");
    }
  }

  // Business validation
  const businessField = fieldlist.find(field => field.referal_name === 'business_id');
  if (businessField) {
    const businessValue = document.getElementById(businessField.referal_name)?.value;
    if (!businessValue) {
      formErrors[businessField.referal_name] = "Business is required";
      setBusinessError("Business is required");
    } else {
      setBusinessError("");
    }
  }

  // Image validation
  const imageField = fieldlist.find(field => field.referal_name === 'images');
  if (imageField) {
    if (selectedImages.length === 0) {
      formErrors[imageField.referal_name] = "Image is required";
      setImageError("Image is required");
    } else {
      setImageError("");
    }
  }


    fieldlist.forEach(field => {
      if (field.show_in === 'Items List' && field.status === 'Active' &&
        (field.item_in_invoice === 'Both' || field.item_in_invoice === 'Items')) {
        const value = document.getElementById(field.referal_name)?.value;
        if (field.is_required && !value) {
          formErrors[field.referal_name] = `${field.field_lable} is required`;
        }
      }
    });

    console.log("formErrors : ", formErrors)
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const sliderStyle = {
    width: '100%',
    maxWidth: '900px',
    margin: '0 auto',
  }

  const ImageSlideshow = ({ images }) => {
    if (images.length === 1) {
      return (
        <div style={{ ...sliderStyle, textAlign: 'center' }}>
          <img src={getFileUrl(images[0])} alt="Single Image" style={imageStyle} />
        </div>
      );
    }

    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      pauseOnHover: true,
      arrows: true,
    };


    return (
      <div style={sliderStyle}>
        <Slider {...settings}>
          {images.map((image, index) => (
            <div key={index} style={slideStyle}>
              <img src={getFileUrl(image)} alt={`Slide ${index + 1}`} style={imageStyle} />
            </div>
          ))}
        </Slider>
      </div>
    );
  };

  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem('language'));
    fetchDynamicData();
  }, []);

  const fetchDynamicData = async () => {
    try {
      const response = await ItemService.get_cruds_dynamic_data(authData.sessionID);
      if (response.data.message === "Unauthorized") {
        AuthService.logout();
        navigate("/login");
        window.location.reload();
      } else {
        const data = response.data;
        var custom_fields = data;
        for (var i = 0; i < custom_fields.length; i++) {
          if (custom_fields[i].options_collection !== '') {
            const _id = authData.userData._id;
            const optresponse = await ItemService.getoptions(custom_fields[i].options_collection, "", {}, 5000, authData.sessionID, _id);
            const optdata = optresponse.data.data;
            var options = [];
            for (var j = 0; j < optdata.length; j++) {
              options.push({ 
                label: optdata[j][custom_fields[i].Options_Field_Name], 
                value: optdata[j]._id, 
                business_id: optdata[j]?.business_id ? optdata[j].business_id.toString() : null, 
                status: optdata[j]?.Status ? optdata[j].Status.toString() : null
              });
            }
            custom_fields[i].options = options;
          }
          if (custom_fields[i].parent_col === pre_params.Parent_referal_name) {
            custom_fields[i].default_value = pre_params.Parentid;
          } else {
            custom_fields[i].default_value = "";
          }
        }
        
        data[0].custom_fields = custom_fields;
        setcollectionlist(data[0]);
        setfieldlist(data[0].custom_fields);
  
        // Automatically select business and filter categories if there's only one business
        const businessField = custom_fields.find(field => field.referal_name === 'business_id');
        if (businessField && businessField.options.length === 1) {
          const businessId = businessField.options[0].value.toString();
          setSelectedBusiness(businessId);
          
          const categoryField = custom_fields.find(field => field.referal_name === 'category');
          if (categoryField && categoryField.options) {
            const categories = categoryField.options.filter(option => option.business_id && option.business_id.toString() === businessId);
            setFilteredCategories(categories);
          }
        }
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  async function handleSubmit(e) {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }

    var requestData = {};
    var field_errors = [];

    for (var i in fieldlist) {
      var field = fieldlist[i];
      if (field.show_in === 'Items List' && field.status === 'Active') {
        if (field.item_in_invoice === 'Both' || field.item_in_invoice === 'Items') {
          if (field.field_type === 'radio') {
            const elements1 = document.querySelectorAll('.prop' + field.referal_name + ':checked');
            var elementvalue = elements1.length > 0 ? elements1[0].value : null;
            requestData[field.referal_name] = elementvalue;
          } else if (field.field_type === 'checkbox') {
            const elements1 = document.querySelectorAll('.prop' + field.referal_name + ':checked');
            var elementvalue = elements1.length > 0 ? elements1.map(element => element.value) : 0;
            requestData[field.referal_name] = elementvalue;
          } else {
            var fieldvalue = document.getElementById(field.referal_name)?.value;
            requestData[field.referal_name] = fieldvalue;
          }
        }
      }
    }

    requestData.functionName = "AddItems";
    requestData.formId = collectionlist._id;
    requestData.user_type_id = collectionlist._id;
    requestData.Images = selectedImages;
    requestData.item_name = item_name;
    requestData.description = description;
    // requestData.amount = amount;
    requestData.item_type = itemType;

    if (field_errors.length === 0) {
      setLoading(true);
      ItemService.save_item(requestData, authData.sessionID)
        .then((response) => {
          setLoading(false);
          if (response.data.status) {
            navigate("/items-list");
            if (response.data.message) {
              Alerts.swalSuccessAlert(response.data.message);
            } else {
              Alerts.swalSuccessAlert("Data added successfully.");
            }
          } else {
            if (response.data.message === "Unauthorized") {
              AuthService.logout();
              navigate("/login");
              window.location.reload();
            } else {
              Alerts.swalErrorAlert(response.data.message || "Error: Can't add data at the moment. Please try again later.");
            }
          }
        })
        .catch((error) => {
          setLoading(false);
          Alerts.swalErrorAlert("Network Operation failed.");
        });
    }
  }
  const [selectedBusiness, setSelectedBusiness] = useState('');
  const [filteredCategories, setFilteredCategories] = useState([]);

  const handleBusinessChange = (event) => {
    const businessId = event.target.value;
    setSelectedBusiness(businessId);
    // Filter categories based on the selected business
    const categories = fieldlist.find(field => field.referal_name === 'category').options.filter(option => option.business_id.toString() === businessId);
    setFilteredCategories(categories);
  };

  useEffect(() => {
    if (business.length === 1 && fieldlist.length > 0) {
      const businessId = business[0].toString();
      setSelectedBusiness(businessId);
      
      const categoryField = fieldlist.find(field => field.referal_name === 'category');
      if (categoryField && categoryField.options) {
        const categories = categoryField.options.filter(option => option.business_id && option.business_id.toString() === businessId);
        setFilteredCategories(categories);
      }
    }
  }, [business, fieldlist]);

  return (
    <>
      <GlobalStyle />
      <div className="app-main__outer">
        <div className="app-main__inner">
          <div className="app-page-title">
            <div className="page-title-wrapper justify-content-left">
              <div className="page-title-heading fw-bold">
                <div className="page-title-icon">
                  <i className="pe-7s-plus icon-gradient bg-happy-green" />
                </div>
                <div>
                  {t("Add Items")}
                  <div className="page-title-subheading">
                    {t('Fill the form below to add Items')}.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-center">
            <div className="col-md-6">
              <Card className="main-card mb-3">
                <CardBody>
                  <LoadingOverlay
                    tag="div"
                    active={loading}
                    styles={{ overlay: (base) => ({ ...base }) }}
                    spinner={<DNALoader />}
                  >
                    <Form onSubmit={handleSubmit} ref={form}>
                      <div className="row">
                        <div className="col-md-12 col-xl-12">
                          <div className="form-group">
                            <label htmlFor="item_name">{t("Item Name")} <span style={{ color: "red" }}>*</span></label>
                            <input
                              type='text'
                              value={item_name}
                              onChange={(e) => setItem_name(e.target.value)}
                              className={`form-control ${errors.item_name ? 'is-invalid' : ''}`}
                              placeholder={t("Item Name")}
                              name="item_name"
                              id="item_name"
                            />
                            {errors.item_name && <div className="invalid-feedback">{errors.item_name}</div>}
                          </div>
                        </div>
                      </div>
                      <br />
                      <div className="row">
                        <div className="col-md-12 col-xl-12">
                          <div className="form-group">
                            <label htmlFor="description">{t("Description")} <span style={{ color: "red" }}>*</span></label>
                            <input
                              value={description}
                              onChange={(e) => setDescription(e.target.value)}
                              type='text'
                              className={`form-control ${errors.description ? 'is-invalid' : ''}`}
                              placeholder={t("Description")}
                              name="description"
                              id="description"
                            />
                            {errors.description && <div className="invalid-feedback">{errors.description}</div>}
                          </div>
                        </div>
                      </div>
                      <br />
                      {/* <div className="row">
                        <div className="col-md-12 col-xl-12">
                          <div className="form-group">
                            <label htmlFor="amount">{t("Price")} <span style={{ color: "red" }}>*</span></label>
                            <input
                              value={amount}
                              onChange={(e) => setamount(e.target.value)}
                              type='number'
                              className={`form-control ${errors.amount ? 'is-invalid' : ''}`}
                              placeholder={t("Price")}
                              name="amount"
                              id="amount"
                            />
                            {errors.amount && <div className="invalid-feedback">{errors.amount}</div>}
                          </div>
                        </div>
                      </div> */}
                      <br />
                      <div className="row">
                        <div className="col-md-12 col-xl-12">
                          <div className="form-group">
                            <label htmlFor="item_type">Item Type <span style={{ color: "red" }}>*</span></label>
                            <select
                              value={itemType}
                              onChange={(e) => setItemType(e.target.value)}
                              className={`form-select ${errors.item_type ? 'is-invalid' : ''}`}
                              name='item_type'
                              id='item_type'
                            >
                              <option value="">{t('--Choose an option--')}</option>
                              <option value='Medicines'>{t("Medicines")}</option>
                              <option value='IOT Devices'>{t("IOT Devices")}</option>
                            </select>
                            {errors.item_type && <div className="invalid-feedback">{errors.item_type}</div>}
                          </div>
                        </div>
                      </div>
                      <br />
                      {fieldlist && fieldlist.map((field, index) => {
                        if (field.show_in === 'Items List' && field.status === 'Active') {
                          if (field.item_in_invoice === 'Both' || field.item_in_invoice === 'Items') {


                            if (field.field_type === 'text' || field.field_type === 'email' || field.field_type === 'number' || field.field_type === 'password' || field.field_type === 'file') {
                              if (field.referal_name === 'images') {
                                return (
                                  <>
                                    <div className="row" key={index}>
                                      <div className="col-md-12 col-xl-12" >
                                        <div className="form-group" >
                                          <label htmlFor="name">{field.field_lable}
                                            <span style={{ color: "red" }}>*</span>
                                            {/* <span id={field.referal_name + "error-box"} style={{ color: "red" }}></span> */}
                                          </label>
                                          <input
                                            type='file'
                                            accept="image/*"
                                            multiple
                                            className={`form-control ${errors[field.referal_name] ? 'is-invalid' : ''}`}
                                            placeholder={field.field_lable}
                                            name={field.referal_name}
                                            id={field.referal_name}
                                            onChange={handleFileChange}
                                          />
                                          {errors[field.referal_name] && (
                                            <div className="invalid-feedback">{errors[field.referal_name]}</div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                    <br />
                                    {selectedImages.length > 0 && (
                                      <div className="row">
                                        <div className="col-md-12 col-xl-12">
                                          <ImageSlideshow images={selectedImages} />
                                        </div>
                                      </div>
                                    )}

                                  </>
                                )
                              } else {
                                return (
                                  <>
                                    <div className="row" key={index}>
                                      <div className="col-md-12 col-xl-12" >
                                        <div className="form-group" >
                                          <label htmlFor={field.referal_name}>{field.field_lable}
                                            <span style={{ color: "red" }}>*</span>
                                          </label>
                                          <input
                                            type={field.field_type}
                                            className={`form-control ${errors[field.referal_name] ? 'is-invalid' : ''}`}
                                            placeholder={field.field_lable}
                                            name={field.referal_name}
                                            id={field.referal_name}
                                          />
                                          {errors[field.referal_name] && (
                                            <div className="invalid-feedback">{errors[field.referal_name]}</div>
                                          )}

                                        </div>
                                      </div>
                                    </div>
                                    <br />
                                  </>
                                )
                              }
                            }
                            else if (field.field_type === 'dropdown') {
                              if (field.referal_name === 'business_id') {
                                return (
                                  <div className="row" key={index} style={{ display:  'none' }}>
                                    <div className="col-md-12 col-xl-12" >
                                      <div className="form-group" >
                                        <label htmlFor={field.referal_name}>{field.field_lable}
                                          <span style={{ color: "red" }}>*</span>
                                        </label>
                                        <select
                                          name={field.referal_name}
                                          id={field.referal_name}
                                          className={`form-select form-control ${errors[field.referal_name] ? 'is-invalid' : ''}`}
                                          onChange={handleBusinessChange}
                                          value={selectedBusiness}
                                        >
                                          {field.options.map((option, optionsindex) => {
                                            if (super_admin || business.some(b => b.toString() === option.value.toString())) {
                                              return (
                                                <option key={field.referal_name + optionsindex} value={option.value}>
                                                  {option.label}
                                                </option>
                                              );
                                            }
                                            return null;
                                          })}
                                        </select>
                                        {errors[field.referal_name] && (
                                          <div className="invalid-feedback">{errors[field.referal_name]}</div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  
                                );
                              } else if (field.referal_name === 'category') {
                                return (
                                  <div className="row" key={index}>
                                    <div className="col-md-12 col-xl-12">
                                      <div className="form-group">
                                        <label htmlFor={field.referal_name}>{field.field_lable}
                                          <span style={{ color: 'red' }}>*</span>
                                        </label>
                                        <select
                                          name={field.referal_name}
                                          id={field.referal_name}
                                          className={`form-select form-control ${errors[field.referal_name] ? 'is-invalid' : ''}`}
                                        >
                                          <option value="">{t('--Choose an option--')}</option>
                                          {filteredCategories
                                              .filter(option => option.status === 'Active')
                                              .map((option, optionsindex) => (
                                                <option key={optionsindex} value={option.value}>
                                                  {option.label}
                                                </option>
                                              ))}
                                        </select>
                                        {errors[field.referal_name] && (
                                          <div className="invalid-feedback">{errors[field.referal_name]}</div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                );
                              } else {
                                return (
                                  <div className="row" key={index}>
                                    <div className="col-md-12 col-xl-12">
                                      <div className="form-group">
                                        <label htmlFor={field.referal_name}>{field.field_lable}
                                          <span style={{ color: 'red' }}>*</span>
                                        </label>
                                        <select
                                          name={field.referal_name}
                                          id={field.referal_name}
                                          className={`form-select form-control ${errors[field.referal_name] ? 'is-invalid' : ''}`}
                                        >
                                          <option disabled={false} value="">{t('--Choose an option--')}</option>
                                          {field.options.map((option, optionsindex) => (
                                            <option key={field.referal_name + optionsindex} value={option.value}>{option.label}</option>
                                          ))}
                                        </select>
                                        {errors[field.referal_name] && (
                                          <div className="invalid-feedback">{errors[field.referal_name]}</div>
                                        )}
                                      </div>
                                    </div>
                                    <br />
                                  </div>
                                );
                              }
                            }
                            else if (field.field_type === 'radio' || field.field_type === 'checkbox') {
                              return (
                                <>
                                  <div className="row" key={index}>
                                    <div className="col-md-12 col-xl-12" ><label htmlFor="name">{field.field_lable} <span id={field.referal_name + "error-box"} style={{ color: "red" }}></span></label></div>
                                    <br />
                                    <div className="col-md-12 col-xl-12" >
                                      <ul className="child mb-0 p-0">
                                        {field.options.map((option, optionsindex) => (
                                          <li className="form-check form-check-inline">
                                            <input className={"form-check-input prop" + field.referal_name}
                                              type={field.field_type}
                                              value={option.value} name={field.referal_name} id={field.referal_name + optionsindex}
                                            />
                                            <label className="form-check-label" htmlFor="users">
                                              {option.label}
                                            </label>
                                          </li>
                                        ))}
                                      </ul>
                                    </div>
                                  </div>
                                  <br />
                                  {errors[field.referal_name] && <div className="invalid-feedback">{errors[field.referal_name]}</div>}
                                </>
                              )
                            }
                            else {
                              return (
                                <>
                                  <div className="row" key={index}>
                                    <div className="col-md-12 col-xl-12" >
                                      <div className="form-group" >
                                        <label htmlFor="name">{field.field_lable} <span id={field.referal_name + "error-box"} style={{ color: "red" }}></span></label>
                                        <input type="text"
                                          className={`form-control ${errors[field.referal_name] ? 'is-invalid' : ''}`}
                                          placeholder={field.field_lable} name={field.referal_name} id={field.referal_name} />
                                        {errors[field.referal_name] && <div className="invalid-feedback">{errors[field.referal_name]}</div>}
                                      </div>
                                    </div>
                                  </div>
                                  <br />


                                </>
                              )
                            }
                          }
                        }
                      })}
                      <br />
                      <div className="row">
                        <div className="col-md-12 col-xl-12" >
                          <center>
                            <button type="button" onClick={() => navigate(-1)} className="btn btn-outline-light btn-hover-shine me-3 mt-3">{t('Cancel')}</button>
                            <button className="btn btn-custom-color btn-hover-shine me-3 mt-3" >{t('Add data')}</button>
                          </center>
                        </div>
                      </div>
                    </Form>
                  </LoadingOverlay>
                </CardBody>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </>
  );


}

export default DriverInsertionForm;